import { TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

export type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

export const AdoptBudgetMixErrorModal = ({ isOpen, closeModal }: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={closeModal}
    titleContent={
      <span className="text-lg font-semibold">
        There was an problem adopting your budget!
      </span>
    }
  >
    <div className="flex flex-col justify-between items-start h-[100px]">
      <div className="flex flex-col gap-4 justify-start items-start">
        <span className="text-sm text-mars">
          Please try again later, thank you for your patience!
        </span>
      </div>
      <div className="flex justify-end items-center w-full gap-2">
        <TertiaryButton onClick={closeModal}>CLOSE</TertiaryButton>
      </div>
    </div>
  </Modal>
);
